import { TrucksService } from "@/TruckSelection/services/Trucks.Service";
import { TeamSelectionService } from "@/TeamSelection/services/TeamSelection.Service";

export const ApiPrefetcher = {
  fetchComplaints(teams: Array<any>): Promise<Array<any>> {
    const complaintsSet: Array<string> = teams.reduce(
      (complaints: Array<string>, team: any) =>
        !complaints.includes(team.complaintSet) ? complaints.push(team.complaintSet) && complaints : complaints,
      [],
    );

    return Promise.all(complaintsSet.map((complaintSet: string) => TeamSelectionService.getComplaintSet(complaintSet)));
  },

  fetchTrucks(teams: Array<any>) {
    return Promise.all(teams.map((team: any) => TrucksService.getData(team.id)));
  },
};
